import React, { useState, useEffect } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import useWindow from '../../hooks/useWindow'
import { singleChartWidth, chartHeight, post2, list2 } from '../../services';
import moment from 'moment';
import exportingModule from "highcharts/modules/exporting";
import exportDataModule from 'highcharts/modules/export-data'
exportingModule(Highcharts);
exportDataModule(Highcharts);

export const InterestHistoryChart = ({ param }) => {
    const [options, setOptions] = useState({})
    const size = useWindow()

    const [exp, setExp] = useState(false)
    useEffect(() => {
        async function fetch() {
            const auth = await list2('auth')
            setExp(auth === true)
        }
        fetch()
    }, [])
        
    useEffect(() => {
        const { name, strip, data } = param
        const options = {
            chart: {
                type: 'spline',
                width: singleChartWidth(size.width),
                height: chartHeight(size.height, 200)
            },
            exporting: exp ? {
                buttons: {
                    contextButton: {
                        enabled: true,
                        align: 'left',
                        menuItems: ["downloadPNG", "downloadPDF", "downloadCSV", "separator",
                            {   
                                text: 'Send Email', 
                                onclick: function() {
                                    const csv = this.getCSV()
                                    const html = this.getSVG()
                                    const title = this.getFilename()
                                    post2('user/export_file', { csv, html, title })
                                } 
                            }
                        ]
                    }
                }
            } : {
                buttons: {
                    contextButton: {
                        enabled: false
                    }    
                }
            },
            title: { text: `${name} OI History` },
            subtitle: { text: strip, align: 'right' },
            xAxis: {
                title: { text: 'Date' },
                categories: data.map(d => moment(d.date).format('YYYY-MM-DD')),
                tickInterval: Math.ceil(data.length / 10)
            },
            yAxis: { title: { text: '' } },
            plotOptions: { spline: { marker: { enabled: false } } },
            series: [
                {
                    name: 'Open Interest',
                    data: data.map(d => d.openint)
                }
            ]
        }
        setOptions(options)
    }, [param, size, exp])

    return <div className='row-center'>
        <HighchartsReact highcharts={Highcharts} options={options} />
    </div>

}